export default class CopyUrl {
    constructor() {

        this.btnCopyLink = document.querySelectorAll('.btnCopyLink');
        this.copyLink();
    }

    copyLink() {
        const btnCopyLink = document.querySelectorAll('.btnCopyLink');

        if (btnCopyLink) {
            btnCopyLink.forEach(btn => {
                btn.addEventListener('click', () => {
                    const url = window.location.href + '?utm_source=share-site&utm_medium=blog&utm_campaign=grupo-v2';
                    navigator.clipboard.writeText(url).then(() => {
                        console.log('URL copiada para o clipboard: ' + url);

                        // Exibir o label .labelCopyUrl
                        const label = btn.closest('li').querySelector('.labelCopyUrl');
                        if (label) {
                            label.classList.remove('hidden');

                            // Remover o label após 5 segundos
                            setTimeout(() => {
                                label.classList.add('hidden');
                            }, 5000);
                        }
                    }).catch(err => {
                        console.error('Erro ao copiar a URL: ', err);
                    });
                });
            });
        }
    }
}

new CopyUrl();